let language = {
    DELIVERY_ORDER_BILLING_ADDRESS: "Billing address:",
    DELIVERY_ORDER_SHIPPING_ADDRESS: "Shipping address:",
    DELIVERY_ORDER_STORE_NAME: "Store name:",
    DELIVERY_ORDER_TRACKING_NUMBER: "Tracking no:",
    DELIVERY_ORDER_DELIVERY_TYPE: "Delivery Method:",
    DELIVERY_ORDER_DELIVERY_DATE: "Delivery date:",
    DELIVERY_ORDER_PAYMENT_TYPE: "Payment Method:",
    DELIVERY_ORDER_REMARK: "Remark:",
    DELIVERY_ORDER_SOURCE_ORDER: "Source order:",
    DELIVERY_ORDER_PRICE: "Price:",
    DELIVERY_ORDER_WEIGHT: "Weight:",
    DELIVERY_ORDER_TOTAL_PRICE: "total price:",
    DELIVERY_ORDER_TOTAL_WEIGHT: "total weight:",

    // 
    DELIVERY_ORDER_PREVIEW_BTN: "PREVIEW",
};

export { language }